import { useState, useMemo, useCallback } from 'react';
import { clearStoredUser, getStoredUser, setStoredUser } from '../utils/safeLocalStorage';

/**
 * Centralized hook for managing user data from localStorage
 * Provides memoized user object to prevent unnecessary re-renders
 */
export const useUser = () => {
    const [user, setUser] = useState(() => getStoredUser());

    // Memoize to prevent component re-renders from this hook alone
    const memoizedUser = useMemo(() => user, [user]);

    const updateUser = useCallback((newUser) => {
        const stored = setStoredUser(newUser);
        setUser(stored);
    }, []);

    const clearUser = useCallback(() => {
        setUser(null);
        clearStoredUser();
    }, []);

    return { user: memoizedUser, updateUser, clearUser };
};
